import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import type { Market } from 'src/interfaces/market'
import { MarketFormContent } from './MarketFormContent'
import { marketFormValidator } from './MarketForm.validator'
import type { MarketFormMode, MarketFormValues } from './MarketForm.interface'

interface Props {
  formId: string
  mode: MarketFormMode
  market: Market | null
  onSubmit(values: MarketFormValues): void
}

const MarketFormComponent = ({ formId, mode, market, onSubmit }: Props) => {
  const initialValues = useMemo<MarketFormValues>(() => {
    return {
      title: market?.title ?? '',
      description: market?.description ?? '',
    }
  }, [market])

  const handleSubmit = useCallback(
    (values: MarketFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<MarketFormValues>
      initialValues={initialValues}
      validationSchema={marketFormValidator}
      // Reopening the modal on a different row must reseed the fields.
      enableReinitialize
      onSubmit={handleSubmit}
    >
      <Form id={formId}>
        <MarketFormContent mode={mode} />
      </Form>
    </Formik>
  )
}

export const MarketForm = memo(MarketFormComponent)
